<app-crudbar-nav #crudbar [title]="title" [visible]="false" (onReady)="doComReady($event, 'crudbar-nav')">
</app-crudbar-nav>

<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start"
  class="h-full"
  style="vertical-align: top;" animationDuration="0ms" dynamicHeight
  (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">
    <div class="border-2 border-red-300">
      <app-jkaggrid #myGrid  [columnDefs]="srv.columnDefs"
        (afterGridReadyAg)="afterGridReady($event)" (rowClicked)="agRowClicked($event)"
        (rowSelected)="agRowSelected($event)" (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)"></app-jkaggrid>

    </div>
  </mat-tab>
  <mat-tab #myTabDetail label="明細">
    <!-- <app-syssh-tabedit [srv]="srv"></app-syssh-tabedit> -->
    <div style="max-height: 400px; overflow-y: auto;">
          <app-jktext  label="功能分類" [value]="item.SH011"     >
    </app-jktext>
    <app-jktextarea  height="250px"
 label="html內容" #SH019Com  id="SH019"  [(value)]="item.SH019" [readonly]="true"     >
    </app-jktextarea>
    <app-jkcheckboxYN  label="註記碼" #SH018Com  id="SH018"  [(valueYN)]="item.SH018"  [readonly]="true"     >
    </app-jkcheckboxYN>
    <app-jktextarea  height="250px"
 label="說明" #SH017Com  id="SH017"  [(value)]="item.SH017" [readonly]="true"     >
    </app-jktextarea>
    <app-jkcheckboxYN  label="客製程式碼" #SH016Com  id="SH016"  [(valueYN)]="item.SH016"  [readonly]="true"     >
    </app-jkcheckboxYN>
    <app-jkcheckboxYN  label="生效碼" #SH015Com  id="SH015"  [(valueYN)]="item.SH015"  [readonly]="true"     >
    </app-jkcheckboxYN>
    <app-jktext  label="用於系統" [value]="item.SH014"     >
    </app-jktext>
    <app-jktext  label="建檔者代號" [value]="item.SH013"     >
    </app-jktext>
    <app-jktext  label="序號" [value]="item.SH012"     >
    </app-jktext>
    <app-jktext  label="程式代號" [value]="item.SH001"     >
    </app-jktext>
    <app-jktext  label="功能簡介" [value]="item.SH010"     >
    </app-jktext>
    <app-jktext  label="版次" [value]="item.SH009"     >
    </app-jktext>
    <app-jktext  label="文管代號" [value]="item.SH008"     >
    </app-jktext>
    <app-jktext  label="類型" [value]="item.SH006"     >
    </app-jktext>
    <app-jktextarea  height="250px"
 label="備註" #SH004Com  id="SH004"  [(value)]="item.SH004" [readonly]="true"     >
    </app-jktextarea>
    <app-jktext  label="網址" [value]="item.SH003"     >
    </app-jktext>
    <app-jktext  label="名稱" [value]="item.SH002"     >
    </app-jktext>

    </div>
  </mat-tab>
  <mat-tab #myTabAdvance label="進階">

  </mat-tab>
</mat-tab-group>
